import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { locations } from 'services/routes/locations';

import seo from 'services/locales/en/seo';
import { toCamelCase } from '../general/getParams';

interface PageTitle {
  pageTitle: string;
  pageDescription: string;
  isNoIndex?: boolean;
}

export const useGetPageTitle = (): PageTitle => {
  const { pathname, search } = useLocation();
  const urlParams = new URLSearchParams(search);
  const { t } = useTranslation();

  const mood = urlParams.get('moods');
  const genre = urlParams.get('genres');
  // @ts-ignore
  const genreParam = toCamelCase(genre);
  // @ts-ignore
  const moodParam = toCamelCase(mood);
  const key = genreParam ? 'Genre' : 'Mood';
  let pageTitle = '';
  let pageDescription = '';
  let isNoIndex;

  if (pathname === locations.general.songList.pathname) {
    pageTitle = t(seo.homepage.title);
    pageDescription = t(seo.homepage.description);
  }
  if (pathname === locations.general.aiMusicGenerator.pathname) {
    pageTitle = t(seo.aiGenerator.title);
    pageDescription = t(seo.aiGenerator.description);
  }
  if (pathname === locations.subscription.pricing.pathname('')) {
    pageTitle = t(seo.pricing.title);
    pageDescription = t(seo.pricing.description);
  }
  if (pathname === locations.account.overview.pathname) {
    pageTitle = t(seo.account.title);
    pageDescription = t(seo.account.description);
  }
  if (pathname === locations.library.pathname) {
    pageTitle = t(seo.library.title);
    pageDescription = t(seo.library.description);
  }
  if (pathname === locations.account.subscription.pathname) {
    pageTitle = t(seo.subscription.title);
    pageDescription = t(seo.subscription.description);
  }
  if (pathname === locations.general.login.pathname) {
    pageTitle = t(seo.login.title);
    pageDescription = t(seo.login.description);
  }
  if (pathname === locations.general.register.route) {
    pageTitle = t(seo.register.title);
    pageDescription = t(seo.register.description);
  }
  // Render pageTitle and pageDescription accordingly to selected Tag
  if (genreParam || moodParam) {
    pageTitle = t(seo.selectedTags.title).replace(
      /value/g,
      genreParam || moodParam
    );
    pageDescription = t(seo.selectedTags.description)
      .replace(/value/g, genreParam || moodParam)
      .replace(/key/g, key);
  }
  if (
    pathname.includes('account') ||
    pathname.includes('terms') ||
    pathname.includes('license') ||
    pathname.includes('privacy') ||
    pathname.includes('imprint')
  ) {
    isNoIndex = true;
  }

  return { pageTitle, pageDescription, isNoIndex };
};
